<template>
	<div>
		<h1>Options Component</h1>

		<!-- START RESPONSE TYPE COMPONENT -->
		<div>
			<tooltip label="Data Type" placement="right">
				<select class="form-control" v-model="commandResponse.resp_component_resp_data_type"
					@change="(d) => { multiple = (commandResponse.resp_component_resp_data_type == 'multi') }"
				>
					<option value="multi">{{ $t('Multiple') }}</option>
					<option value="single">{{ $t('Single') }}</option>
				</select>
			</tooltip>
			<tooltip
				label="Data Limit"
				placement="right"
				v-if="multiple"
			>
				<input
					name="resp_component_resp_data_limit"
					v-model.lazy="commandResponse.resp_component_resp_data_limit"
					class="form-control"
					type="text"
				/>
			</tooltip>
			<tooltip label="Response Via" placement="right">
				<select class="form-control" v-model="commandResponse.resp_component_resp_via"
					@change="() => { card = (commandResponse.resp_component_resp_via == 'card'); text = (commandResponse.resp_component_resp_via === 'text')}"
				>
					<option value="text">{{ $t('Text') }}</option>
					<option value="card">{{ $t('Card URL or List') }}</option>
					<option value="video">{{ $t('Video') }}</option>
					<option value="Image">{{ $t('Image') }}</option>
				</select>
			</tooltip>
			<ComamandResponseCard
				v-show="card"
				:buttons="commandResponse.resp_component_resp_struct.buttons"
				:btnLabel="commandResponse.resp_component_resp_struct.item_label_key || commandResponse.resp_component_resp_struct.item_label_default_value"
				:title="commandResponse.resp_component_resp_struct.title_key || commandResponse.resp_component_resp_struct.title_default_value"
				:subTitle="commandResponse.resp_component_resp_struct.subtitle_key || commandResponse.resp_component_resp_struct.subtitle_default_value"
				:autoCompleteModules="autocomplete"
				@onNewButtonClick="push_button(commandResponse.resp_component_resp_struct.buttons)"
				@onRemoveButtonClick="(pos) => remove_button(pos, commandResponse.resp_component_resp_struct.buttons)"
			>
				<template slot="title">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.title_key"
							:placeholder="$t('value')"
							
						/>
					</tooltip>
					<tooltip label="default value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.title_default_value"
							:placeholder="$t('default value')"
							
						/>
					</tooltip>
				</template>
				<template slot="subTitle">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.subtitle_key"
							:placeholder="$t('value')"
							
						/>
					</tooltip>
					<tooltip label="default value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.subtitle_default_value"
							:placeholder="$t('default value')"
							
						/>
					</tooltip>
				</template>
				<template slot="media">
					<tooltip label="value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.media_key"
							:placeholder="$t('value')"
							
						/>
					</tooltip>
					<tooltip label="default value" placement="right">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="commandResponse.resp_component_resp_struct.media_default_value"
							:placeholder="$t('default value')"
							
						/>
					</tooltip>
				</template>

				<template
					:slot="'button.' + ii"
					v-for="(button, ii) in commandResponse.resp_component_resp_struct.buttons"
				>
					<tooltip label="button label" placement="right" :key="'button.label.' + ii">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="button.item_label_key"
							:placeholder="$t('button label')"
							
						/>
					</tooltip>

					<tooltip label="button value" placement="right" :key="'button.value.' + ii">
						<input
							class="form-control"
							v-autocomplete="autocomplete"
							v-model="button.item_value_key"
							:placeholder="$t('button value')"
							
						/>
					</tooltip>
				</template>
			</ComamandResponseCard>

			<tooltip label="text" placement="right" v-show="commandResponse.resp_component_resp_via === 'text'">
				<input
					class="form-control"
					v-autocomplete="autocomplete"
					v-model="commandResponse.resp_component_resp_struct.title_key"
					
				/>
			</tooltip>
		</div>
		<!-- END RESPONSE TYPE COMPONENT -->

	</div>
</template>

<script>
	import ComamandResponseCard from '../../../components/ComamandResponseCard'

	export default {
		components: {
			ComamandResponseCard
		},
		props: {
			commandResponse: {
				// default: () => {},
			}
		},
		data() {
			return {
				card: false,
				multiple: false,
				text: true,
				autocomplete: {},
			}
		},
		methods: {
			push_button(btns_arr) {
				btns_arr.push({
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
				})
			},
			remove_button(pos, btns_arr) {
				btns_arr.splice(pos, 1)
			},
			bindData() {
				this.commandResponse.resp_component_resp_data_type = 'single';
				this.commandResponse.resp_component_resp_data_limit = 1;
				this.commandResponse.resp_component_resp_via = 'text';
				this.commandResponse.resp_component_resp_struct = {
					title_key: '',
					title_default_value: '',
					subtitle_key: '',
					subtitle_default_value: '',
					media_key: '',
					media_default_value: '',
					item_label_key: '',
					item_label_default_value: '',
					item_value_key: '',
					item_value_default_value: '',
					buttons: [
						{
							item_label_key: '',
							item_label_default_value: '',
							item_value_key: '',
							item_value_default_value: '',
						},
					],
				};
			}
		},
		created() {
			this.bindData()
			console.log(this.commandResponse);
			
		},
	}
</script>

<style lang="scss" scoped>
</style>
